import { render, staticRenderFns } from "./important-information-select-creation.view.vue?vue&type=template&id=27c8910c&"
import script from "./important-information-select-creation.view.vue?vue&type=script&lang=ts&"
export * from "./important-information-select-creation.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports